{
  "id": "netflix.com",
  "version": 2,
  "name": "Netflix",
  "author": "SR",
  "date": "2023-05-31",
  "url": "https://www.netflix.com",
  "strings": {
    "en": {
      "name": "Netflix",
      "help": [
        "https://www.netflix.com/account/getmyinfo",
        "(Log in with your Netflix Account)",
        "Click on 'Request Data'",
        "Check your email to accept the request",
        "Wait (about 12-24 hours).",
        "You will receive a follow-up email with instructions to download the data export."
      ]
    },
    "de": {
      "name": "Netflix",
      "help": [
        "https://www.netflix.com/account/getmyinfo",
        "(Melde dich mit deinem Konto an)",
        "Klicke auf 'Archiv anfordern'.",
        "Überprüfe deine Email um die Anfrage zu bestätigen.",
        "Warte (etwa 12-24 Stunden)",
        "Du erhälst eine E-Mail mit Anweisungen zum Herunterladen deines Datenexports."
      ]
    }
  },
  "instructions": [
    {
      "schema": [
        {
          "type": "object",
          "properties": {
            "labelFileName": [{ "type": "string" }],
            "labelFilePath": [{ "type": "string", "supposedUsage": { "format": "uri" } }],
            "labelParentFolderName": [{ "type": "string" }],
            "labelDate": [
              {
                "type": "string",
                "supposedUsage": {
                  "format": "time",
                  "argument": { "iso": true }
                }
              }
            ],
            "data": [
              {
                "type": "array",
                "anyOf": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "Profile Name": [{ "type": "string" }],
                          "Esn": [{ "type": "string" }],
                          "Device Type": [{ "type": "string" }],
                          "Acct First Playback Date": [{ "type": "string" }, { "type": "empty" }],
                          "Acct Last Playback Date": [{ "type": "string" }, { "type": "empty" }],
                          "Acct First Playback Date For User Generated Plays": [
                            { "type": "string" },
                            { "type": "empty" }
                          ],
                          "Acct Last Playback Date For User Generated Plays": [
                            { "type": "string" },
                            { "type": "empty" }
                          ],
                          "Profile First Playback Date": [{ "type": "string" }, { "type": "empty" }],
                          "Profile Last Playback Date": [{ "type": "string" }, { "type": "empty" }],
                          "Profile First Playback Date For User Generated Plays": [
                            { "type": "string" },
                            { "type": "empty" }
                          ],
                          "Profile Last Playback Date For User Generated Plays": [
                            { "type": "string" },
                            { "type": "empty" }
                          ],
                          "Deactivation Time": [{ "type": "string" }]
                        }
                      }
                    ]
                  }
                ]
              }
            ]
          }
        }
      ],
      "templates": [
        {
          "path": ["data", null],
          "category": "Security",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null, null] }],
          "selectedTimestamps": [
            {
              "path": ["data", null, null, "Acct First Playback Date For User Generated Plays"],
              "arguments": { "iso": true },
              "template": ["data", null]
            },
            {
              "path": ["data", null, null, "Acct First Playback Date"],
              "arguments": { "iso": true },
              "template": ["data", null]
            },
            {
              "path": ["data", null, null, "Profile First Playback Date"],
              "arguments": { "iso": true },
              "template": ["data", null]
            },
            {
              "path": ["data", null, null, "Profile Last Playback Date"],
              "arguments": { "iso": true },
              "template": ["data", null]
            },
            {
              "path": ["data", null, null, "Acct Last Playback Date For User Generated Plays"],
              "arguments": { "iso": true },
              "template": ["data", null]
            },
            {
              "path": ["data", null, null, "Profile First Playback Date For User Generated Plays"],
              "arguments": { "iso": true },
              "template": ["data", null]
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "object",
          "properties": {
            "labelFileName": [{ "type": "string" }],
            "labelFilePath": [{ "type": "string", "supposedUsage": { "format": "uri" } }],
            "labelParentFolderName": [{ "type": "string" }],
            "labelDate": [
              {
                "type": "string",
                "supposedUsage": {
                  "format": "time",
                  "argument": { "iso": true }
                }
              }
            ],
            "data": [
              {
                "type": "array",
                "anyOf": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "Profile Name": [{ "type": "string" }],
                          "Title Name": [
                            {
                              "type": "string",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "iso": true }
                              }
                            }
                          ],
                          "Country": [{ "type": "string" }],
                          "Utc Title Add Date": [
                            {
                              "type": "string",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "lang": "en" }
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                ]
              }
            ]
          }
        }
      ],
      "templates": [
        {
          "path": ["data", null],
          "category": "Likes",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null, null] }],
          "selectedTimestamps": [
            {
              "path": ["data", null, null, "Utc Title Add Date"],
              "arguments": { "lang": "en" },
              "template": ["data", null]
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "object",
          "properties": {
            "labelFileName": [{ "type": "string" }],
            "labelFilePath": [{ "type": "string", "supposedUsage": { "format": "uri" } }],
            "labelParentFolderName": [{ "type": "string" }],
            "labelDate": [
              {
                "type": "string",
                "supposedUsage": {
                  "format": "time",
                  "argument": { "iso": true }
                }
              }
            ],
            "data": [
              {
                "type": "array",
                "anyOf": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "Profile Name": [{ "type": "string" }],
                          "Start Time": [
                            {
                              "type": "string",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "iso": true }
                              }
                            }
                          ],
                          "Duration": [
                            {
                              "type": "string",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "lang": "en" }
                              }
                            }
                          ],
                          "Attributes": [{ "type": "string" }],
                          "Title": [{ "type": "string" }],
                          "Supplemental Video Type": [{ "type": "string" }],
                          "Device Type": [{ "type": "string" }],
                          "Bookmark": [
                            {
                              "type": "string",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "lang": "en" }
                              }
                            }
                          ],
                          "Latest Bookmark": [
                            {
                              "type": "string",
                              "supposedUsage": { "format": "lat" }
                            }
                          ],
                          "Country": [{ "type": "string" }]
                        }
                      }
                    ]
                  }
                ]
              }
            ]
          }
        }
      ],
      "templates": [
        {
          "path": ["data", null],
          "category": "Activity",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null, null] }],
          "selectedTimestamps": [
            {
              "path": ["data", null, null, "Start Time"],
              "arguments": { "iso": true },
              "template": ["data", null]
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [["data", null, null, "Latest Bookmark"]],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "object",
          "properties": {
            "labelFileName": [{ "type": "string" }],
            "labelFilePath": [{ "type": "string", "supposedUsage": { "format": "uri" } }],
            "labelParentFolderName": [{ "type": "string" }],
            "labelDate": [
              {
                "type": "string",
                "supposedUsage": {
                  "format": "time",
                  "argument": { "iso": true }
                }
              }
            ],
            "data": [
              {
                "type": "array",
                "anyOf": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "Profile Name": [{ "type": "string" }],
                          "Country Iso Code": [{ "type": "string" }],
                          "Device": [{ "type": "string" }],
                          "Is Kids": [{ "type": "string" }],
                          "Query Typed": [{ "type": "string" }],
                          "Displayed Name": [{ "type": "string" }, { "type": "empty" }],
                          "Action": [{ "type": "string" }],
                          "Section": [{ "type": "string" }],
                          "Utc Timestamp": [
                            {
                              "type": "string",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "iso": true }
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                ]
              }
            ]
          }
        }
      ],
      "templates": [
        {
          "path": ["data", null],
          "category": "Activity",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null, null] }],
          "selectedTimestamps": [
            {
              "path": ["data", null, null, "Utc Timestamp"],
              "arguments": { "iso": true }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "object",
          "properties": {
            "labelFileName": [{ "type": "string" }],
            "labelFilePath": [{ "type": "string", "supposedUsage": { "format": "uri" } }],
            "labelParentFolderName": [{ "type": "string" }],
            "labelDate": [
              {
                "type": "string",
                "supposedUsage": {
                  "format": "time",
                  "argument": { "iso": true }
                }
              }
            ],
            "data": [
              {
                "type": "array",
                "anyOf": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "Profile Name": [{ "type": "string" }],
                          "Title Description": [{ "type": "string" }],
                          "Device": [{ "type": "string" }],
                          "Playback Start Utc Ts": [
                            {
                              "type": "string",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "iso": true }
                              }
                            }
                          ],
                          "Country": [{ "type": "string" }],
                          "Playtraces": [{ "type": "string" }]
                        }
                      }
                    ]
                  }
                ]
              }
            ]
          }
        }
      ],
      "templates": [
        {
          "path": ["data", null],
          "category": "Activity",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null, null] }],
          "selectedTimestamps": [
            {
              "path": ["data", null, null, "Playback Start Utc Ts"],
              "arguments": { "iso": true }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "object",
          "properties": {
            "labelFileName": [{ "type": "string" }],
            "labelFilePath": [{ "type": "string", "supposedUsage": { "format": "uri" } }],
            "labelParentFolderName": [{ "type": "string" }],
            "labelDate": [
              {
                "type": "string",
                "supposedUsage": {
                  "format": "time",
                  "argument": { "iso": true }
                }
              }
            ],
            "data": [
              {
                "type": "array",
                "anyOf": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "Profile Name": [{ "type": "string" }],
                          "Title Name": [{ "type": "string" }],
                          "Rating Type": [{ "type": "string" }],
                          "Star Value": [{ "type": "string" }, { "type": "empty" }],
                          "Thumbs Value": [{ "type": "string" }],
                          "Device Model": [{ "type": "string" }],
                          "Event Utc Ts": [
                            {
                              "type": "string",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "iso": true }
                              }
                            }
                          ],
                          "Region View Date": [{ "type": "string" }, { "type": "empty" }]
                        }
                      }
                    ]
                  }
                ]
              }
            ]
          }
        }
      ],
      "templates": [
        {
          "path": ["data", null],
          "category": "Likes",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null, null] }],
          "selectedTimestamps": [
            {
              "path": ["data", null, null, "Event Utc Ts"],
              "arguments": { "iso": true }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "object",
          "properties": {
            "labelFileName": [{ "type": "string" }],
            "labelFilePath": [{ "type": "string", "supposedUsage": { "format": "uri" } }],
            "labelParentFolderName": [{ "type": "string" }],
            "labelDate": [
              {
                "type": "string",
                "supposedUsage": {
                  "format": "time",
                  "argument": { "iso": true }
                }
              }
            ],
            "data": [
              {
                "type": "array",
                "anyOf": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "Profile Name": [{ "type": "string" }],
                          "Title Desc": [{ "type": "string" }],
                          "Selection Type": [{ "type": "string" }],
                          "Choice Segment Id": [{ "type": "string" }],
                          "Has Watched": [{ "type": "string" }],
                          "Source": [{ "type": "string" }],
                          "Utc Timestamp": [
                            {
                              "type": "string",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "iso": true }
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                ]
              }
            ]
          }
        }
      ],
      "templates": [
        {
          "path": ["data", null],
          "category": "Activity",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null, null] }],
          "selectedTimestamps": [
            {
              "path": ["data", null, null, "Utc Timestamp"],
              "arguments": { "iso": true }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "object",
          "properties": {
            "labelFileName": [{ "type": "string" }],
            "labelFilePath": [{ "type": "string", "supposedUsage": { "format": "uri" } }],
            "labelParentFolderName": [{ "type": "string" }],
            "labelDate": [
              {
                "type": "string",
                "supposedUsage": {
                  "format": "time",
                  "argument": { "iso": true }
                }
              }
            ],
            "data": [
              {
                "type": "array",
                "anyOf": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "Profile Name": [{ "type": "string" }],
                          "Show": [{ "type": "string" }],
                          "Has Watched": [{ "type": "string" }],
                          "Is Interested": [{ "type": "string" }],
                          "Event Date": [
                            {
                              "type": "string",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "lang": "en" }
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                ]
              }
            ]
          }
        }
      ],
      "templates": [
        {
          "path": ["data", null],
          "category": "Activity",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null, null] }],
          "selectedTimestamps": [
            {
              "path": ["data", null, null, "Event Date"],
              "arguments": { "lang": "en" }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "object",
          "properties": {
            "labelFileName": [{ "type": "string" }],
            "labelFilePath": [{ "type": "string", "supposedUsage": { "format": "uri" } }],
            "labelParentFolderName": [{ "type": "string" }],
            "labelDate": [
              {
                "type": "string",
                "supposedUsage": {
                  "format": "time",
                  "argument": { "iso": true }
                }
              }
            ],
            "data": [
              {
                "type": "array",
                "anyOf": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "First Name": [{ "type": "string" }],
                          "Last Name": [{ "type": "string" }],
                          "Email Address": [{ "type": "string" }],
                          "Phone Number": [{ "type": "string" }],
                          "Country Of Registration": [{ "type": "string" }],
                          "Country Of Signup": [{ "type": "string" }],
                          "Primary Lang": [{ "type": "string" }],
                          "Cookie Disclosure": [{ "type": "string" }],
                          "Membership Status": [{ "type": "string" }],
                          "Customer Creation Timestamp": [
                            {
                              "type": "string",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "iso": true }
                              }
                            }
                          ],
                          "Profile Transfer Setting": [{ "type": "string" }],
                          "Has Rejoined": [{ "type": "string" }],
                          "Netflix Updates": [{ "type": "string" }],
                          "Now On Netflix": [{ "type": "string" }],
                          "Netflix Offers": [{ "type": "string" }],
                          "Netflix Surveys": [{ "type": "string" }],
                          "Netflix Kids And Family": [{ "type": "string" }],
                          "Sms Account Related": [
                            {
                              "type": "string",
                              "supposedUsage": { "format": "lat" }
                            }
                          ],
                          "Sms Content Updates And Special Offers": [{ "type": "string" }],
                          "Test Participation": [{ "type": "string" }],
                          "Marketing Communications Matched Identifiers": [{ "type": "string" }],
                          "Extra Member Account": [{ "type": "string" }],
                          "Extra Member Primary Account Owner": [{ "type": "string" }, { "type": "empty" }]
                        }
                      }
                    ]
                  }
                ]
              }
            ]
          }
        }
      ],
      "templates": [
        {
          "path": ["data", null],
          "category": "Account",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null, null] }],
          "selectedTimestamps": [
            {
              "path": ["data", null, null, "Customer Creation Timestamp"],
              "arguments": { "iso": true }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "object",
          "properties": {
            "labelFileName": [{ "type": "string" }],
            "labelFilePath": [{ "type": "string", "supposedUsage": { "format": "uri" } }],
            "labelParentFolderName": [{ "type": "string" }],
            "labelDate": [
              {
                "type": "string",
                "supposedUsage": {
                  "format": "time",
                  "argument": { "iso": true }
                }
              }
            ],
            "data": [
              {
                "type": "array",
                "anyOf": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "Tou Accepted Date": [
                            {
                              "type": "string",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "iso": true }
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                ]
              }
            ]
          }
        }
      ],
      "templates": [
        {
          "path": ["data", null],
          "category": "Account",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null, null] }],
          "selectedTimestamps": [
            {
              "path": ["data", null, null, "Tou Accepted Date"],
              "arguments": { "iso": true }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "object",
          "properties": {
            "labelFileName": [{ "type": "string" }],
            "labelFilePath": [{ "type": "string", "supposedUsage": { "format": "uri" } }],
            "labelParentFolderName": [{ "type": "string" }],
            "labelDate": [
              {
                "type": "string",
                "supposedUsage": {
                  "format": "time",
                  "argument": { "iso": true }
                }
              }
            ],
            "data": [
              {
                "type": "array",
                "anyOf": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "Subscription Opened Ts": [
                            {
                              "type": "string",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "iso": true }
                              }
                            }
                          ],
                          "Is Free Trial At Signup": [{ "type": "string" }],
                          "Subscription Closed Ts": [{ "type": "string" }, { "type": "empty" }],
                          "Is Customer Initiated Cancel": [{ "type": "string" }, { "type": "empty" }],
                          "Signup Plan Category": [{ "type": "string" }],
                          "Signup Max Concurrent Streams": [{ "type": "string" }],
                          "Signup Max Streaming Quality": [{ "type": "string" }],
                          "Plan Change Date": [{ "type": "string" }],
                          "Plan Change Old Category": [{ "type": "string" }],
                          "Plan Change Old Max Concurrent Streams": [{ "type": "string" }],
                          "Plan Change Old Max Streaming Quality": [{ "type": "string" }],
                          "Plan Change New Category": [{ "type": "string" }],
                          "Plan Change New Max Concurrent Streams": [{ "type": "string" }],
                          "Plan Change New Max Streaming Quality": [{ "type": "string" }],
                          "Cancellation Reason": [
                            {
                              "type": "string",
                              "supposedUsage": { "format": "lat" }
                            },
                            { "type": "empty" }
                          ]
                        }
                      }
                    ]
                  }
                ]
              }
            ]
          }
        }
      ],
      "templates": [
        {
          "path": ["data", null],
          "category": "Account",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null, null] }],
          "selectedTimestamps": [
            {
              "path": ["data", null, null, "Subscription Opened Ts"],
              "arguments": { "iso": true }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "object",
          "properties": {
            "labelFileName": [{ "type": "string" }],
            "labelFilePath": [{ "type": "string", "supposedUsage": { "format": "uri" } }],
            "labelParentFolderName": [{ "type": "string" }],
            "labelDate": [
              {
                "type": "string",
                "supposedUsage": {
                  "format": "time",
                  "argument": { "iso": true }
                }
              }
            ],
            "data": [
              {
                "type": "array",
                "anyOf": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "Profile Name": [{ "type": "string" }],
                          "Email Address": [{ "type": "string" }, { "type": "empty" }],
                          "Game Handle": [{ "type": "string" }, { "type": "empty" }],
                          "Profile Creation Time": [
                            {
                              "type": "string",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "iso": true }
                              }
                            }
                          ],
                          "Maturity Level": [{ "type": "string" }],
                          "Primary Lang": [{ "type": "string" }],
                          "Has Auto Playback": [{ "type": "string" }],
                          "Max Stream Quality": [{ "type": "string" }],
                          "Profile Lock Enabled": [{ "type": "string" }],
                          "Profile Transferred": [{ "type": "string" }],
                          "Profile Transfer Time": [{ "type": "string" }, { "type": "empty" }],
                          "Profile Transferred From Account": [{ "type": "string" }, { "type": "empty" }],
                          "Profile Transferred To Account": [{ "type": "string" }, { "type": "empty" }],
                          "Date Of Birth": [{ "type": "string" }, { "type": "empty" }],
                          "Gender": [{ "type": "string" }, { "type": "empty" }],
                          "Opt-Out": [{ "type": "string" }]
                        }
                      }
                    ]
                  }
                ]
              }
            ]
          }
        }
      ],
      "templates": [
        {
          "path": ["data", null],
          "category": "Account",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null, null] }],
          "selectedTimestamps": [
            {
              "path": ["data", null, null, "Profile Creation Time"],
              "arguments": { "iso": true }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "object",
          "properties": {
            "labelFileName": [{ "type": "string" }],
            "labelFilePath": [{ "type": "string", "supposedUsage": { "format": "uri" } }],
            "labelParentFolderName": [{ "type": "string" }],
            "labelDate": [
              {
                "type": "string",
                "supposedUsage": {
                  "format": "time",
                  "argument": { "iso": true }
                }
              }
            ],
            "data": [
              {
                "type": "array",
                "anyOf": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "Profile Name": [{ "type": "string" }],
                          "Icons": [{ "type": "string" }]
                        }
                      }
                    ]
                  }
                ]
              }
            ]
          }
        }
      ],
      "templates": [],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "object",
          "properties": {
            "labelFileName": [{ "type": "string" }],
            "labelFilePath": [{ "type": "string", "supposedUsage": { "format": "uri" } }],
            "labelParentFolderName": [{ "type": "string" }],
            "labelDate": [
              {
                "type": "string",
                "supposedUsage": {
                  "format": "time",
                  "argument": { "iso": true }
                }
              }
            ],
            "data": [
              {
                "type": "array",
                "anyOf": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "Profile Name": [{ "type": "string" }],
                          "Source": [{ "type": "string" }],
                          "Navigation Level": [{ "type": "string" }],
                          "Referrer Url": [{ "type": "string" }, { "type": "empty" }],
                          "Webpage Url": [{ "type": "string" }, { "type": "empty" }],
                          "Click Utc Ts": [
                            {
                              "type": "string",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "iso": true }
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                ]
              }
            ]
          }
        }
      ],
      "templates": [
        {
          "path": ["data", null],
          "category": "Activity",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null, null] }],
          "selectedTimestamps": [
            {
              "path": ["data", null, null, "Click Utc Ts"],
              "arguments": { "iso": true }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "object",
          "properties": {
            "labelFileName": [{ "type": "string" }],
            "labelFilePath": [{ "type": "string", "supposedUsage": { "format": "uri" } }],
            "labelParentFolderName": [{ "type": "string" }],
            "labelDate": [
              {
                "type": "string",
                "supposedUsage": {
                  "format": "time",
                  "argument": { "iso": true }
                }
              }
            ],
            "data": [
              {
                "type": "array",
                "anyOf": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "Profile Name": [{ "type": "string" }],
                          "Sent Utc Ts": [
                            {
                              "type": "string",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "iso": true }
                              }
                            }
                          ],
                          "Message Name": [{ "type": "string" }],
                          "Channel": [{ "type": "string" }],
                          "Country Iso Code": [{ "type": "string" }],
                          "Account Locale": [{ "type": "string" }],
                          "Email Locale": [{ "type": "string" }],
                          "Title Name": [{ "type": "string" }],
                          "Email Domain Name": [{ "type": "string" }],
                          "Link Url": [{ "type": "string" }, { "type": "empty" }],
                          "Click Utc Ts": [{ "type": "string" }, { "type": "empty" }],
                          "Device Model": [
                            {
                              "type": "string",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "iso": true }
                              }
                            }
                          ],
                          "Click Cnt": [{ "type": "string" }]
                        }
                      }
                    ]
                  }
                ]
              }
            ]
          }
        }
      ],
      "templates": [
        {
          "path": ["data", null],
          "category": "Messages",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null, null] }],
          "selectedTimestamps": [
            {
              "path": ["data", null, null, "Sent Utc Ts"],
              "arguments": { "iso": true },
              "template": ["data", null]
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "object",
          "properties": {
            "labelFileName": [{ "type": "string" }],
            "labelFilePath": [{ "type": "string", "supposedUsage": { "format": "uri" } }],
            "labelParentFolderName": [{ "type": "string" }],
            "labelDate": [
              {
                "type": "string",
                "supposedUsage": {
                  "format": "time",
                  "argument": { "iso": true }
                }
              }
            ],
            "data": [
              {
                "type": "array",
                "anyOf": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "Transaction Date": [
                            {
                              "type": "string",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "lang": "en" }
                              }
                            }
                          ],
                          "Service Period Start Date": [{ "type": "string" }, { "type": "empty" }],
                          "Service Period End Date": [{ "type": "string" }, { "type": "empty" }],
                          "Description": [{ "type": "string" }],
                          "Payment Type": [{ "type": "string" }],
                          "Mop Last 4": [{ "type": "string" }],
                          "Mop Creation Date": [{ "type": "string" }, { "type": "empty" }],
                          "Mop Pmt Processor Desc": [{ "type": "string" }, { "type": "empty" }],
                          "Item Price Amt": [{ "type": "string" }, { "type": "empty" }],
                          "Currency": [{ "type": "string" }],
                          "Tax Amt": [{ "type": "string" }, { "type": "empty" }],
                          "Gross Sale Amt": [{ "type": "string" }],
                          "Pmt Txn Type": [{ "type": "string" }],
                          "Pmt Status": [{ "type": "string" }],
                          "Final Invoice Result": [{ "type": "string" }, { "type": "empty" }],
                          "Country": [{ "type": "string" }],
                          "Next Billing Date": [{ "type": "string" }, { "type": "empty" }]
                        }
                      }
                    ]
                  }
                ]
              }
            ]
          }
        }
      ],
      "templates": [
        {
          "path": ["data", null],
          "category": "Account",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null, null] }],
          "selectedTimestamps": [
            {
              "path": ["data", null, null, "Transaction Date"],
              "arguments": { "lang": "en" }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "object",
          "properties": {
            "labelFileName": [{ "type": "string" }],
            "labelFilePath": [{ "type": "string", "supposedUsage": { "format": "uri" } }],
            "labelParentFolderName": [{ "type": "string" }],
            "labelDate": [
              {
                "type": "string",
                "supposedUsage": {
                  "format": "time",
                  "argument": { "iso": true }
                }
              }
            ],
            "data": [
              {
                "type": "array",
                "anyOf": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "Esn": [{ "type": "string" }],
                          "Country": [{ "type": "string" }],
                          "Region Code": [{ "type": "string" }],
                          "Device Description": [{ "type": "string" }],
                          "Ip": [{ "type": "string" }],
                          "Ts": [
                            {
                              "type": "string",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "iso": true }
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                ]
              }
            ]
          }
        }
      ],
      "templates": [
        {
          "path": ["data", null],
          "category": "Security",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null, null] }],
          "selectedTimestamps": [
            {
              "path": ["data", null, null, "Ts"],
              "arguments": { "iso": true }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "object",
          "properties": {
            "labelFileName": [{ "type": "string" }],
            "labelFilePath": [{ "type": "string", "supposedUsage": { "format": "uri" } }],
            "labelParentFolderName": [{ "type": "string" }],
            "labelDate": [
              {
                "type": "string",
                "supposedUsage": {
                  "format": "time",
                  "argument": { "iso": true }
                }
              }
            ],
            "data": [
              {
                "type": "array",
                "anyOf": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "Esn": [{ "type": "string" }],
                          "Country": [{ "type": "string" }],
                          "Localized Device Description": [{ "type": "string" }],
                          "Device Description": [{ "type": "string" }],
                          "Ip": [{ "type": "string" }],
                          "Region Code Display Name": [{ "type": "string" }],
                          "Ts": [
                            {
                              "type": "string",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "iso": true }
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                ]
              }
            ]
          }
        }
      ],
      "templates": [
        {
          "path": ["data", null],
          "category": "Security",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null, null] }],
          "selectedTimestamps": [
            {
              "path": ["data", null, null, "Ts"],
              "arguments": { "iso": true }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    }
  ],
  "fileStructure": [
    "DEVICES/",
    "CONTENT_INTERACTION/",
    "ACCOUNT/",
    "PROFILES/",
    "CLICKSTREAM/",
    "MESSAGES/",
    "PAYMENT_AND_BILLING/",
    "IP_ADDRESSES/",
    "SURVEYS/",
    "CUSTOMER_SERVICE/",
    "GAMES/"
  ],
  "optionalFileStructure": []
}
